import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import Avatar from 'srcReact/components/common2/Avatar'
import IconButton from 'srcReact/components/common2/IconButton'
import { TextArea } from 'srcReact/components/common2/TextArea'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Spinner from 'srcReact/components/common2/Spinner'

const FinalizeInvitationsModal = (props) => {
  const { members, sendInvites, id, callback, closeModal, removeMember } = props
  const { t } = useTranslation()
  const dispatch = useDispatch()
  // const [membersInvited, setMembersInvited] = useState(members)
  const [membersId, setMembersId] = useState([])
  const [inviteTriggered, setInviteTriggered] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [message, setMessage] = useState({
    name: 'message',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: false
  })

  const {
    mixr: {
      invitation: { error: eventInviteError, sending }
    }
  } = useSelector((state) => state)

  const handleSubmit = () => {
    if (membersId.length > 0) {
      setInviteTriggered(true)
      sendInvites(id, membersId.join(','), message.value, callback)
    }
  }

  useEffect(() => {
    if (eventInviteError && inviteTriggered) {
      setErrorMessage(t('popinFinalizeInvitations.error'))
    } else {
      setErrorMessage('')
    }
  }, [eventInviteError])

  useEffect(() => {
    if (members?.length === 0) {
      if (closeModal) {
        closeModal()
      }
    } else {
      setMembersId(members?.map((e) => e.id))
    }
  }, [members])

  const showUserModal = (e, user) => {
    if (e) {
      e.stopPropagation()
    }
    const lp = new LightProfileProto()
    lp.userId = user.id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  return (
    <div className={styles.invitationContainer}>
      {/* <h1 className={styles.title}>{t('popinFinalizeInvitations.title')}</h1> */}
      <h2 className={styles.subTitle}>{t('popinFinalizeInvitations.text', { count: members.length })}</h2>
      <div className={styles.members}>
        {members?.length > 0 &&
          members.map((member) => (
            <div className={styles.member} key={member.id}>
              <Avatar
                imgWrapperSize='small50'
                containerCSS={styles.avatar}
                userId={member.id}
                profilePicture={member.profile_picture ?? member.profile_picture_data.profile_picture}
                firstname={member.firstname}
                lastname={member.lastname}
                mimeType={member.mime_type ?? member.profile_picture_data.mime_type}
                originalTag={member.original_tag ?? member.profile_picture_data.original_tag}
                isOriginal={member.is_original ?? member.profile_picture_data.is_original}
                deleteMode={true}
                deleteAction={() => removeMember(member.id)}
                showUserName={members.length < 5}
                onClickAction={(e) => showUserModal(e, member)}
                withExpertiseGroup={member.with_expertise_group}
              />
            </div>
          ))}
      </div>
      <TextArea
        rows={8}
        isRequired={false}
        fieldInfo={message}
        label={t('popinFinalizeInvitations.message')}
        onChange={(e) => setMessage({ ...message, value: e.target.value })}
        customWrapperCss={styles.message}
        placeholder={t('global.placeholder')}
      />
      <div className={styles.buttons}>
        <Button size='large' style='secondary' text={t('global.cancel')} handleClick={closeModal} />
        <Button size='large' text={t('global.sendInvites')} handleClick={handleSubmit} />
      </div>
      {sending && inviteTriggered && <Spinner />}
      {errorMessage ? <ErrorMessage text={errorMessage} className={styles.error} center={true} /> : null}
    </div>
  )
}

export default FinalizeInvitationsModal
